import script from "./StatsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsTable.vue?vue&type=script&setup=true&lang=js"

import "./StatsTable.vue?vue&type=style&index=0&id=e9636704&lang=css"

const __exports__ = script;

export default __exports__